import Swiper, { Navigation, Pagination, Lazy } from "swiper";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import "swiper/css/effect-fade";

const $ = jQuery;

export default class Swipers {
    constructor(options = null) {}

    init() {
        this.__swiper();
    }

    __swiper() {
        const $swiperBlocks = $(".image_carousel_swiper_block");

        // Iterate through both sets of Swiper blocks
        $swiperBlocks.each((index, swiperBlock) => {
            if (!swiperBlock) return;

            const swiperBlockId = $(swiperBlock).attr("id");

            // Initialize the main Swiper
            const mainSwiper = new Swiper(`#${swiperBlockId}`, {
                speed: 1000,
                slidesPerView: 1,
                loop: true,
                spaceBetween: 0,
                preloadImages: true, // Disable default image preload
                lazy: {
                    loadPrevNext: true, // Load the previous and next slides
                    loadPrevNextAmount: 3, // Number of slides to preload before they come into view
                },
                navigation: {
                    nextEl: `.swiper-next-${swiperBlockId}`,
                    prevEl: `.swiper-prev-${swiperBlockId}`,
                },
                pagination: {
                    el: `.swiper-pagination-${swiperBlockId}`,
                    type: "bullets",
                    clickable: false,
                },
                loopAdditionalSlides: 3,
                modules: [Navigation, Pagination, Lazy],
            });
        });
    }
}
